import { CardEventCategory } from "app/pages/sales-intelligence/services/tracking/home-page/types";
import createTrackingEventName from "app/pages/sales-intelligence/utils/testing/createTrackingEventName";

export const getCardEventName = (eventCategory: CardEventCategory, totalResults: number): string => {
    switch (eventCategory) {
        case CardEventCategory.Lists:
            return createTrackingEventName("lists card hover", totalResults);
        case CardEventCategory.SavedSearches:
            return createTrackingEventName("saved searches card hover", totalResults);
        case CardEventCategory.CsvEnrichment:
            return createTrackingEventName("csv enrichment card hover", totalResults);
        default:
            return `unknown event name for category: ${eventCategory}`;
    }
};

export const getViewAllEventName = (eventCategory: CardEventCategory): string => {
    switch (eventCategory) {
        case CardEventCategory.Lists:
            return "view all lists button";
        case CardEventCategory.SavedSearches:
            return "view saved searches button";
        default:
            return `unknown event name for category: ${eventCategory}`;
    }
};

export const getFirstNewAssetEventName = (eventCategory: CardEventCategory): string => {
    switch (eventCategory) {
        case CardEventCategory.Lists:
            return "Add list button";
        case CardEventCategory.SavedSearches:
            return "set your ICP button";
        case CardEventCategory.CsvEnrichment:
            return "upload csv button";
        default:
            return `unknown event name for category: ${eventCategory}`;
    }
};

export const getNewAssetEventName = (eventCategory: CardEventCategory): string => {
    switch (eventCategory) {
        case CardEventCategory.Lists:
            return "Add list button";
        case CardEventCategory.SavedSearches:
            return "new search button";
        case CardEventCategory.CsvEnrichment:
            return "CSV enrichment button";
        default:
            return `unknown event name for category: ${eventCategory}`;
    }
};

export const getRedirectToAssetClickEventName = (eventCategory: CardEventCategory): string => {
    switch (eventCategory) {
        case CardEventCategory.Lists:
            return "click list";
        case CardEventCategory.SavedSearches:
            return "click saved search";
        default:
            return `unknown event name for category: ${eventCategory}`;
    }
};

export const getRedirectToSignalsClickEventName = (eventCategory: CardEventCategory): string => {
    switch (eventCategory) {
        case CardEventCategory.Lists:
            return "see list signals";
        case CardEventCategory.SavedSearches:
            return "see saved search signals";
        default:
            return `unknown event name for category: ${eventCategory}`;
    }
};

export const getRedirectToSignalsHoverEventName = (eventCategory: CardEventCategory): string => {
    switch (eventCategory) {
        case CardEventCategory.Lists:
            return "interest in list signals";
        case CardEventCategory.SavedSearches:
            return "interest in saved search signals";
        default:
            return `unknown event name for category: ${eventCategory}`;
    }
};
